import React, {useState} from 'react';
import {Button, Modal, Spinner} from "@tag/tag-components-react-v4";
import styles from './DataExportModal.module.scss';
import {OrganisationDTO} from "../../../types/OrganisationDTO";
import OrganisationService from "../../../services/OrganisationService";
import { ProjectAccents } from "../../../../General/config/projectAccents";

function DataExportModal(props: { visible: boolean, selectedOrganisation: OrganisationDTO, handleClose: Function, setAlert: Function, handleCustomerMenuModalClose: Function }) {

    const [loading, setLoading] = useState<string|undefined>('');
    const handleDataExport = async () => {
        setLoading('Downloading...');
        try {
            const generateResponse = await OrganisationService.generateDataExport(props.selectedOrganisation.id, props.selectedOrganisation.environmentName);
            
            // Create a temporary URL for the blob
            const blobUrl = URL.createObjectURL(generateResponse.blob);
            
            // Create an anchor element and trigger download
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = generateResponse.filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // Revoke the blob URL to free memory
            URL.revokeObjectURL(blobUrl);
            
            setLoading(undefined);
        } catch (e) {
            setLoading(undefined);
            props.setAlert({type: 'error', message: 'An error has occured with the data export, please contact HSC Care DevOps'});
            props.handleClose();
            props.handleCustomerMenuModalClose();
        }
    }
    
    const renderModalContent = () => {
        let modalContent;
        
        if (loading) {
            modalContent = (
                <div className={styles.DataExportModalLoaderContainer}>
                    <Spinner>{loading}</Spinner>
                </div>
            )
        } else {
            modalContent = (
                <div className={styles.DataExportModalButtonContainer}>
                    <div className={styles.DataExportModalButtonElement}>
                        <Button
                            text={'Organisation Export'}
                            onClick={() => handleDataExport()}
                        />
                    </div>
                </div>
            )
        }

        return modalContent;
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PoliciesAndProcedures}
            heading={'Data Export'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default DataExportModal;
